<template>
  <slide class="slide-wrapper">
    <div class="slide-content-wrapper">
      <slot></slot>
    </div>
  </slide>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "AppGallerySlide",
  components: {
    Carousel,
    Slide
  },
  props: {}
};
</script>

<style scoped lang="scss" type="text/scss"></style>
